
<div class="gt-routes-list-containerss">
  <div class="col-container">
    <div class="col">
      <h2 class="col-title" i18n="@@documentTypes"> Document Types </h2>
      <dx-data-grid
        #documentTypesGrid
        class="property-config-grid"
        [dataSource]="documentTypes"
        (onSaved)="saveDocumentType($event)"
        [repaintChangesOnly]="true"
      >
        <dxo-selection mode="single"></dxo-selection>
        <dxo-search-panel
          [visible]="true"
          [highlightCaseSensitive]="false"
          class="gt-search-panel"
          width="17vw"
        ></dxo-search-panel>
        <dxo-toolbar>
          <dxi-item width="50%" name="searchPanel" location="before"></dxi-item>
          <dxi-item width="50%">
            <div class="gt-flex-dir-row">
              <app-gpd-button
                icon="add"
                i18n-text="@@add"
                text="Add"
                (onClick)="addNewContractType()"
              ></app-gpd-button>
            </div>
          </dxi-item>
        </dxo-toolbar>
        <dxo-editing mode="form" [texts]="editText"></dxo-editing>
        <dxi-column
          dataField="documentType"
          i18n-caption="@@documentType"
          caption="Document Type"
          sortOrder="asc"
        >
          <dxi-validation-rule
            type="required"
            i18n-message="@@documentTypeIsRequired"
            message="Document Type is required"
          ></dxi-validation-rule>
          <dxi-validation-rule
            type="custom"
            i18n-message="@@documentTypeExists"
            [validationCallback]="validateDocumentTypeDuplicateName"
            message="Document Type already exists"
          ></dxi-validation-rule>
        </dxi-column>

        <dxi-column
          dataField="code"
          i18n-caption="@@code"
          caption="Code"
          sortOrder="asc"
        >
        <dxi-validation-rule
            type="required"
            i18n-message="@@documentTypeCodeIsRequired"
            message="Document Type Code is required"
          ></dxi-validation-rule>
          <dxi-validation-rule
            type="custom"
            i18n-message="@@documentTypeExists"
            [validationCallback]="validateDocumentTypeDuplicateCode"
            message="Document Type already exists"
          ></dxi-validation-rule>
        </dxi-column>

        <dxi-column
          dataField=""
          allowEditing="false"
          cellTemplate="buttonCellTemplate"
          [width]="68"
          [visible]="true"
          [formItem]="{ visible: false }"
        >
          <div *dxTemplate="let item of 'buttonCellTemplate'">
            <div class="gpd-table-actions">
                <app-svg-icon icon="edit" color="var(--color-primary)" [size]="20" [strokeWidth]="1.5" i18n-title="@@edit" title="Edit" [class.disabled]="userPermissions.isAdministrator == false || userPermissions.canEdit == false" (click)="!(userPermissions.isAdministrator == false || userPermissions.canEdit == false) && editDocumentType(item.data.id)"></app-svg-icon>
                <app-svg-icon icon="delete" color="var(--color-red-500)" [size]="20" [strokeWidth]="1.5" i18n-title="@@delete" title="Delete" [class.disabled]="userPermissions.isAdministrator == false || userPermissions.canDelete == false" (click)="!(userPermissions.isAdministrator == false || userPermissions.canDelete == false) && deleteDocumentType(item.data)"></app-svg-icon>
              </div>
          </div>
        </dxi-column>
      </dx-data-grid>
    </div>

    <div class="col">
      <h2 class="col-title" i18n="@@propertyAreaTypes"> Property Area Types </h2>
      <dx-data-grid
        #propertyAreaTypesGrid
        class="property-config-grid"
        [dataSource]="propertyAreaTypes"
        (onSaved)="savePropertyAreaType($event)"
        [repaintChangesOnly]="true"
      >
        <dxo-selection mode="single"></dxo-selection>
        <dxo-search-panel
          [visible]="true"
          [highlightCaseSensitive]="false"
          class="gt-search-panel"
          width="17vw"
        ></dxo-search-panel>
        <dxo-toolbar>
          <dxi-item width="50%" name="searchPanel" location="before"></dxi-item>
          <dxi-item width="50%">
            <div class="gt-flex-dir-row">
              <app-gpd-button
                icon="add"
                i18n-text="@@add"
                text="Add"
                (onClick)="addNewPropertyAreaType()"
              ></app-gpd-button>
            </div>
          </dxi-item>
        </dxo-toolbar>
        <dxo-editing mode="form" [texts]="editText"></dxo-editing>
        <dxi-column
          dataField="name"
          i18n-caption="@@name"
          caption="Name"
          sortOrder="asc"
        >
          <dxi-validation-rule
            type="required"
            i18n-message="@@nameIsRequired"
            message="Name is required"
          ></dxi-validation-rule>
          <dxi-validation-rule
            type="custom"
            i18n-message="@@nameExists"
            [validationCallback]="validatePropertyAreaTypeDuplicateName"
            message="Name already exists"
          ></dxi-validation-rule>
        </dxi-column>
        <dxi-column
          dataField=""
          allowEditing="false"
          cellTemplate="buttonCellTemplate"
          [width]="68"
          [visible]="true"
          [formItem]="{ visible: false }"
        >
          <div *dxTemplate="let item of 'buttonCellTemplate'">
            <div class="gpd-table-actions">
                <app-svg-icon icon="edit" color="var(--color-primary)" [size]="20" [strokeWidth]="1.5" i18n-title="@@edit" title="Edit" [class.disabled]="userPermissions.isAdministrator == false || userPermissions.canEdit == false" (click)="!(userPermissions.isAdministrator == false || userPermissions.canEdit == false) && editPropertyAreaType(item.data.id)"></app-svg-icon>
                <app-svg-icon icon="delete" color="var(--color-red-500)" [size]="20" [strokeWidth]="1.5" i18n-title="@@delete" title="Delete" [class.disabled]="userPermissions.isAdministrator == false || userPermissions.canDelete == false" (click)="!(userPermissions.isAdministrator == false || userPermissions.canDelete == false) && deletePropertyAreaType(item.data)"></app-svg-icon>
              </div>
          </div>
        </dxi-column>
      </dx-data-grid>
    </div>
  </div>
</div>
